export default "__VITE_ASSET__24b9f130__"